var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"search--section",class:{
      'search--section--mobile' : _vm.isMobile,
      'search--section--desktop' : !_vm.isMobile,
    }},[_c('div',{staticClass:"title"},[_c('span',[_vm._v("\n        "+_vm._s(_vm.$i18nPresenter.t("Ready-made Presentation Templates"))+"\n      ")])]),_c('div',{staticClass:"search"},[_c('TemplateSearchV2')],1),_c('div',{staticClass:"categories",class:{
        'categories--mobile' : _vm.isMobile,
        'categories--desktop' : !_vm.isMobile,
      }},[_c('CategoryListV2')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }